
//TOAST
export const SET_TOAST = 'SET_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

//AUTHENTICATION
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const USER_RELOADED = 'USER_RELOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_USER = 'CLEAR_USER';

//GUEST
export const GET_GUESTS = 'GET_GUESTS';
export const GUEST_ERROR = 'GUEST_ERROR';
export const CLEAR_GUESTS='CLEAR_GUESTS';

//COMPLAINT
export const ADD_COMPLAINT = 'ADD_COMPLAINT';
export const COMPLAINT_ERROR = 'COMPLAINT_ERROR';
export const GET_MY_COMPLAINTS = 'GET_MY_COMPLAINTS';
export const DELETE_COMPLAINT = 'DELETE_COMPLAINT';
export const CLEAR_COMPLAINTS = 'CLEAR_COMPLAINTS';
export const GET_COMPLAINTS = 'GET_COMPLAINTS';
export const UPDATE_COMPLAINT = 'UPDATE_COMPLAINT';

//EMERGENCY
export const ADD_EMERGENCY = 'ADD_EMERGENCY';
export const EMERGENCY_ERROR = 'EMERGENCY_ERROR';
export const GET_MY_EMERGENCIES = 'GET_MY_EMERGENCIES';
export const DELETE_EMERGENCY = 'DELETE_EMERGENCY';
export const CLEAR_EMERGENCIES = 'CLEAR_EMERGENCIES';
export const GET_EMERGENCIES = 'GET_EMERGENCIES';
export const UPDATE_EMERGENCY = 'UPDATE_EMERGENCY';
export const CHANGE_EMERGENCY_STATUS = 'CHANGE_EMERGENCY_STATUS';
export const EDIT_EMERGENCY = 'EDIT_EMERGENCY';

//CENTRE
export const GET_CENTRES = 'GET_CENTRES';
export const DELETE_CENTRE = 'DELETE_CENTRE';
export const ADD_CENTRE = 'ADD_CENTRE';
export const CENTRE_ERROR = 'CENTRE_ERROR';
export const CLEAR_CENTRES = 'CLEAR_CENTRES';
export const GET_CENTRE_BY_ID = 'GET_CENTRE_BY_ID';
export const EDIT_CENTRE = 'EDIT_CENTRE';
export const GET_MY_CENTRE = 'GET_MY_CENTRE';
export const GET_PUBLIC_CENTRES = 'GET_PUBLIC_CENTRES';

//NOTICE
export const GET_NOTICES = 'GET_NOTICES';
export const ADD_NOTICE = 'ADD_NOTICE';
export const NOTICE_ERROR = 'NOTICE_ERROR';
export const DELETE_NOTICE = 'DELETE_NOTICE';
export const DOWNLOAD_NOTICE = 'DOWNLOAD_NOTICE';

//ALERT
export const ADD_ALERT = 'ADD_ALERT';
export const ALERT_ERROR = 'ALERT_ERROR';
export const GET_ALERTS = 'GET_ALERTS';
export const DELETE_ALERT = 'DELETE_ALERT';
export const SET_HEAD_ALERT = 'SET_HEAD_ALERT';
export const GET_HEAD_ALERT = 'GET_HEAD_ALERT';
export const CHANGE_ALERT_STATUS = 'CHANGE_ALERT_STATUS';
export const REMOVE_HEAD_ALERT = 'REMOVE_HEAD_ALERT';

//HELPLINE 
export const GET_ALL_HELPLINES='GET_ALL_HELPLINES';
export const ADD_HELPLINE='ADD_HELPLINE';
export const DELETE_HELPLINE='DELETE_HELPLINE';
export const HELPLINE_ERROR='HELPLINE_ERROR';

//STAFF
export const ADD_STAFF = 'ADD_STAFF';
export const STAFF_ERROR = 'STAFF_ERROR';
export const GET_STAFFS = 'GET_STAFFS';
export const DELETE_STAFF = 'DELETE_STAFF';
export const CHANGE_STAFF_CENTRE = 'CHANGE_STAFF_CENTRE';
export const CLEAR_STAFF = 'CLEAR_STAFF';

//RESCUED
export const GET_ALL_RESCUES='GET_ALL_RESCUES';
export const ADD_RESCUE='ADD_RESCUE';
export const DELETE_RESCUE='DELETE_RESCUE';
export const RESCUE_ERROR='RESCUE_ERROR';
export const EDIT_RESCUE='EDIT_RESCUE';
export const CLEAR_RESCUES='CLEAR_RESCUES';

// MAP
export const GET_MAP_CENTRES = 'GET_MAP_CENTRES';
export const MAP_CENTRES_ERROR = 'MAP_CENTREs_ERROR';